export default {
  methods: {
    /**
     * @description 根据不同的模式 返回不同的值
     * @param {*} createModeValve 新增模式返回值
     * @param {*} editModeValue 编辑模式返回值
     * @param {*} detailModeValue 详情模式返回值
     * @param {*} defaultValue 没有匹配的模式返回值 默认为 createModeValve
     */
    switchByMode: function switchByMode() {
      var createModeValve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var editModeValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var detailModeValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : createModeValve;

      if (this.mode === 'create') {
        return createModeValve;
      } else if (this.mode === 'edit') {
        return editModeValue;
      } else if (this.mode === 'detail') {
        return detailModeValue;
      } else {
        return defaultValue;
      }
    },

    /**
     * @description 设置表单模式
     * @param {String} mode 模式名称 edit or create
     */
    setMode: function setMode(mode) {
      this.mode = mode;
    }
  }
};